// extracted by mini-css-extract-plugin
module.exports = {"askQuestionTopText":"Qs","yourQuestionLabel":"Rs","notAuthedMessage":"Ss","form":"Ts","textarea":"Us","error":"Vs","disabled":"Ws","edited":"Xs","submit":"Ys"};